import CreateOrganisationForm from "@/features/organisations/components/CreateOrganisationForm";
import JoinOrganisationForm from "@/features/organisations/components/JoinOrganisationForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

function NewOrganisation() {
    const { copy, goToProfile } = useProfileAttributePage();
    const [mode, setMode] = useState<"join" | "create">("join");

    h.useNav([
        { label: copy.title, route: { to: "/profile" } },
        { label: copy.organisation, route: { to: "/profile/organisation" } },
    ]);

    return (
        <ProfileAttributePage title={copy.organisation} description={copy.profileOrganisationDescription}>
            {mode === "join" ? (
                <JoinOrganisationForm isOnboarding={false} onBack={goToProfile} onCreateNew={() => setMode("create")} />
            ) : (
                <CreateOrganisationForm
                    onBack={goToProfile}
                    onCreated={goToProfile}
                    onSearchInstead={() => setMode("join")}
                />
            )}
        </ProfileAttributePage>
    );
}

export const Route = createFileRoute("/_app/profile/organisation")({
    component: NewOrganisation,
});
